import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { laptopAndAbove, tabletAndAbove } from 'style/mediaQuery';

const Wrapper = styled(Vertical).attrs({ gap: 2 })`
  margin: var(--triple-unit) 0;

  &.inDialog {
    padding: 0 var(--double-unit);
  }
`;

const ItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--double-unit);
  @media ${tabletAndAbove} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  @media ${laptopAndAbove} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  .inDialog & {
    grid-template-columns: repeat(2, 1fr);
  }
`;

type Props<T> = {
  items: T[];
  renderItem: (item: T) => ReactNode;
  hasMore?: boolean;
  sortAndFilters?: ReactNode;
  infiniteScrollLoader?: ReactNode;
  inDialog?: boolean;
};

export const ClubShopItemsGrid = <T,>({
  items,
  renderItem,
  hasMore,
  sortAndFilters = null,
  infiniteScrollLoader = null,
  inDialog = false,
}: Props<T>) => {
  const nbItems = items.length;
  return (
    <Wrapper className={classNames({ inDialog })}>
      <SBHorizontal gap={0}>
        <LabelM color="var(--c-neutral-1000)">
          <FormattedMessage
            id="ClubShop.Items.Number"
            defaultMessage="{number} items"
            values={{ number: hasMore ? `${nbItems}+` : nbItems }}
          />
        </LabelM>
        {sortAndFilters}
      </SBHorizontal>
      <ItemsGrid>{items.map(item => renderItem(item))}</ItemsGrid>
      {infiniteScrollLoader}
    </Wrapper>
  );
};
